import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { AppConfig } from './app.config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(
    public appConfig: AppConfig,
  ) { }

  ngOnInit() {
    moment.locale('pt-BR');
  }
  
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts